import Picker from '../../../common/components/picker/picker';
import { api } from '../../../core/network/api';
import { resolveTier } from '../contexts/tiers';
import { tierPaths } from '../queries/paths';

// Read all pages so a project with more than twenty tiers remains selectable.
async function options(projectId, signal) {
    const items = [];
    let total;
    do {
        const { data } = await api.get(tierPaths.list(), {
            params: { project_id: projectId, limit: 100, offset: items.length }, signal,
        });
        const page = data.items ?? [];
        items.push(...page);
        total = data.pagination?.total ?? items.length;
        if (!page.length) break;
    } while (items.length < total);
    return items;
}

export default function TierFilter({ projectId, value, onChange }) {
    if (!projectId) return null;
    return (
        <label className="project-filter">
            <span className="project-filter__label">Tier</span>
            <Picker
                value={value}
                onChange={onChange}
                fetchOptions={(_q, signal) => options(projectId, signal)}
                resolveOption={resolveTier}
                cacheKey={`board-tiers:${projectId}`}
                labelOf={tier => `#${tier.id} · ${tier.name}`}
                searchable={false}
                hint="Todos los tiers del proyecto seleccionado."
                placeholder="Todos los tiers"
                emptyLabel="Todos los tiers"
            />
        </label>
    );
}
